import {Pipe, PipeTransform} from '@angular/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

// The pipe owns the plugin it needs instead of relying on another feature extending dayjs.
dayjs.extend(relativeTime);

@Pipe({
  name: 'pastTime'
})
export class PastTimePipe implements PipeTransform {
  transform(value: Date | string): unknown {
    return dayjs().to(dayjs(value));
  }
}
